export const contractsMeta = {
    keyExpr: 'kod_vdog',
    scrollingMode: 'standart',
    title: 'Виды договоров',
    columns: [
        {
            name: 'name_obj_upr1',
            caption: 'Объект управления',
            dataField: 'name_obj_upr1',
            allowEditing: true,
            index: 1,
            visible: true,
            fixed: true,
        },
        {
            name: 'name',
            caption: 'Группа потребителей',
            dataField: 'name',
            allowEditing: true,
            index: 2,
            visible: true,
            fixed: true,
        },
        {
            name: 'name_doc',
            caption: 'Вид документа',
            dataField: 'name_doc',
            allowEditing: true,
            index: 3,
            visible: true,
        },
        {
            name: 'sqrp',
            caption: 'Файл шаблона',
            dataField: 'sqrp',
            allowEditing: true,
            index: 4,
            visible: true,
        },
        {
            name: 'day_energy',
            caption: 'Срок в днях до корректировки договорных значений энергии',
            dataField: 'day_energy',
            allowEditing: true,
            index: 5,
            visible: true,
        },
        {
            name: 'day_power',
            caption: 'Срок в днях до корректировки договорных значений мощности',
            dataField: 'day_power',
            allowEditing: true,
            index: 6,
            visible: true,
        },
        {
            name: 'name_tep_el',
            caption: 'Тепло / Электричество',
            dataField: 'name_tep_el',
            allowEditing: true,
            index: 7,
            visible: true,
        },

        {
            name: 'name_tipdog',
            caption: 'Тип договора',
            dataField: 'name_tipdog',
            allowEditing: true,
            index: 8,
            visible: true,
        },
        {
            name: 'name_forma',
            caption: 'Форма договора',
            dataField: 'name_forma',
            allowEditing: true,
            index: 9,
            visible: true,
        },

        {
            name: 'name_byt',
            caption: 'Частный сектор',
            dataField: 'name_byt',
            allowEditing: true,
            index: 10,
            visible: true,
        },
        {
            name: 'status',
            caption: 'Статус',
            dataField: 'status',
            allowEditing: true,
            index: 11,
            visible: true,
            fixed: true,
            fixedPosition: 'right',
        },
        // {
        //     name: 'podr',
        //     caption: 'col_PODR',
        //     dataField: 'podr',
        //     allowEditing: true,
        //     editor: {
        //         type: 'default',
        //         text: '',
        //     },
        //     component: {
        //         name: '',
        //         id: '',
        //         text: '',
        //     },
        //
        //     visible: false,
        // },

        // {
        //     name: 'kod_tipdog',
        //     caption: 'col_KOD_TIPDOG',
        //     dataField: 'kod_tipdog',
        //     allowEditing: true,
        //     editor: {
        //         type: 'default',
        //         text: '',
        //     },
        //     component: {
        //         name: '',
        //         id: '',
        //         text: '',
        //     },
        //
        //     visible: false,
        // },
        // {
        //     name: 'kod_vdog',
        //     caption: 'col_KOD_VDOG',
        //     dataField: 'kod_vdog',
        //     allowEditing: true,
        //     editor: {
        //         type: 'default',
        //         text: '',
        //     },
        //     component: {
        //         name: '',
        //         id: '',
        //         text: '',
        //     },
        //
        //     index: 1,
        //     visible: false,
        // },
        // {
        //     name: 'tep_el',
        //     caption: 'col_TEP_EL',
        //     dataField: 'tep_el',
        //     allowEditing: true,
        //     editor: {
        //         type: 'default',
        //         text: '',
        //     },
        //     component: {
        //         name: '',
        //         id: '',
        //         text: '',
        //     },
        //
        //     visible: false,
        // },
        // {
        //     name: 'kod_vdoc',
        //     caption: 'col_KOD_VDOC',
        //     dataField: 'kod_vdoc',
        //     allowEditing: true,
        //     editor: {
        //         type: 'default',
        //         text: '',
        //     },
        //     component: {
        //         name: '',
        //         id: '',
        //         text: '',
        //     },
        //
        //     visible: false,
        // },

        // {
        //     name: 'byt',
        //     caption: 'col_BYT',
        //     dataField: 'byt',
        //     allowEditing: true,
        //     editor: {
        //         type: 'default',
        //         text: '',
        //     },
        //     component: {
        //         name: '',
        //         id: '',
        //         text: '',
        //     },
        //
        //     visible: false,
        // },
        // {
        //     name: 'public_suite',
        //     caption: 'Учитываются',
        //     dataField: 'public_suite',
        //     allowEditing: true,
        //     editor: {
        //         type: 'default',
        //         text: '',
        //     },
        //     component: {
        //         name: '',
        //         id: '',
        //         text: '',
        //     },
        //
        //     visible: false,
        // },
        // {
        //     name: 'kod_vivod',
        //     caption: 'col_KOD_VIVOD',
        //     dataField: 'kod_vivod',
        //     allowEditing: true,
        //     editor: {
        //         type: 'default',
        //         text: '',
        //     },
        //     component: {
        //         name: '',
        //         id: '',
        //         text: '',
        //     },
        //
        //     visible: false,
        // },

        // {
        //     name: 'name_vivod',
        //     caption: 'col_NAME_VIVOD',
        //     dataField: 'name_vivod',
        //     allowEditing: true,
        //     editor: {
        //         type: 'default',
        //         text: '',
        //     },
        //     component: {
        //         name: '',
        //         id: '',
        //         text: '',
        //     },
        //
        //     visible: false,
        // },
        // {
        //     name: 'forma_dog',
        //     caption: 'col_FORMA_DOG',
        //     dataField: 'forma_dog',
        //     allowEditing: true,
        //     editor: {
        //         type: 'default',
        //         text: '',
        //     },
        //     component: {
        //         name: '',
        //         id: '',
        //         text: '',
        //     },
        //
        //     visible: false,
        // },
    ],
    api: {
        select: 'core./core/ksvdog-view-select/get',
        save: 'core./core/ksvdog-view-save/set',
    },
    viewId: 'ksvdog-view',
};

export const prilMeta = {
    keyExpr: 'kod_namepril',
    scrollingMode: 'standart',
    title: 'Приложения',
    columns: [
        {
            name: 'kodpk_namepril',
            caption: 'col_KODPK_NAMEPRIL',
            dataField: 'kodpk_namepril',
            allowEditing: true,
            editor: { type: 'default', text: '' },
            component: { name: '', id: '', text: '' },

            index: 1,
            visible: false,
        },
        {
            name: 'kod_namepril',
            caption: 'col_KOD_NAMEPRIL',
            dataField: 'kod_namepril',
            allowEditing: true,
            editor: { type: 'default', text: '' },
            component: { name: '', id: '', text: '' },

            index: 2,
            visible: false,
        },
        {
            name: 'name_pril',
            caption: 'Наименование приложения',
            dataField: 'name_pril',
            allowEditing: true,
            editor: { type: 'default', text: '' },
            component: { name: '', id: '', text: '' },

            index: 3,
            visible: true,
        },
        {
            name: 'prim',
            caption: 'Описание приложения',
            dataField: 'prim',
            allowEditing: true,
            editor: { type: 'default', text: '' },
            component: { name: '', id: '', text: '' },

            index: 3,
            visible: true,
        },
        {
            name: 'pril_check',
            caption: '',
            dataField: 'pril_check',
            allowEditing: true,
            editor: { type: 'default', text: '' },
            component: { name: '', id: '', text: '' },

            index: 3,
            visible: true,
        },
        {
            name: 'pr_arx',
            caption: 'Архивное',
            dataField: 'pr_arx',
            allowEditing: true,
            editor: { type: 'default', text: '' },
            component: { name: '', id: '', text: '' },

            index: 3,
            visible: true,
        },
    ],
    api: { select: 'core./core/vdognamepril-view-select/get', save: 'core./core/vdognamepril-view-save/set' },
    viewId: 'vdognamepril-view',
};
export const meta = {
    components: [
        {
            id: 1,
            name: 'ksvdog-view',
            parentComponent: null,
            parentName: '',
            selectUrl: 'core./core/ksvdog-view-select/get',
            save: 'core./core/ksvdog-view-save/set',
        },
        {
            id: 2,
            name: 'vdognamepril-view',
            parentName: 'ksvdog-view',
            parentComponent: 1,
            selectUrl: 'core./core/vdognamepril-view-select/get',
            save: 'core./core/vdognamepril-view-save/set',
        },
    ],
};

export const toolbarConfig = {
    order: [
        {
            name: 'refreshButton',
        },
        {
            name: 'selectButton',
        },
        {
            name: 'copyButton',
        },
        {
            name: 'addRowButton',
        },
        {
            name: 'deleteButton',
        },
        {
            name: 'saveButton',
        },
    ],
};
